module.exports = __webpack_public_path__ + "static/media/arrowRightLongIcon.1ab1c2f3.svg";